import { APP_ID, SERVER_URL } from "./appConfig";
import { getClient } from "./systemInfo";

// Create null state for promise.
let userIdentityPromise = null;

export async function getOrCreateUserIdentity() {
  // If the promise variable is not null, identity creation is already requestsed. Return promise and abort.
  if (userIdentityPromise) return userIdentityPromise;

  // Set the promise variable equal to the result of the async identity creation request, which is a promise until its complete.
  userIdentityPromise = (async () => {
    const stored = localStorage.getItem("user_identity");
    if (stored) {
      try {
        const storedIdentity = JSON.parse(stored);
           console.debug("Previous Identity Found: ", storedIdentity);
        return storedIdentity;
      } catch {}
    }
    try {
      const response = await fetch(`${SERVER_URL}/api/create-user-id`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          appId: APP_ID,
          client: getClient(navigator.userAgent),
        }),
      });

      if (!response.ok) throw new Error("Failed to create new user ID");

      const identity = await response.json();
       console.debug("New Identity Created: ", identity);
      localStorage.setItem("user_identity", JSON.stringify(identity));
      return identity;
    } catch (error) {
      console.error("Failed to get or create user identity: ", error);
      return null;
    } finally {
      // When identity retrieval or creation is done, set promise variable to null so it can be called agian later.
      userIdentityPromise = null;
    }
  })();
  return userIdentityPromise;
}